import { X, Eye, EyeOff, Plus } from 'lucide-react'
import { Formik } from 'formik'
import { useRef, useState } from 'react'
import { Card, Col, Form, Modal, Row } from 'react-bootstrap'
import api from '../../../config/AxiosInstance'
import * as Common from '../../../utils/Common'
import { DriverAddSchema } from '../../../utils/validationSchema'
import CustomButton from '../../Button/CustomButton'
import CustomCloseButton from '../../Button/CustomCloseButton'
import TextField from '../../Input/TextInput'
import SelectInput from '../../Input/SelectInput'
import FilePreviewModal from '../common/FilePreviewModal'

const statuses = [
  { id: 'true', name: 'Active' },
  { id: 'false', name: 'Inactive' }
]

function ModalAddDriver(props) {
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const initialValues =
    props.activeKey === 'internal'
      ? {
          name: '',
          phone_number: '',
          status: 'true',
          address: '',
          username: '',
          password: '',
          typeDriver: props.activeKey
        }
      : {
          name: '',
          status: 'true',
          sim_doc: '',
          ktp_doc: '',
          typeDriver: props.activeKey
        }
  const fileUploadSim = useRef(null)
  const fileUploadKtp = useRef(null)
  const [showPassword, setShowPassword] = useState(false)
  const [fileNameSim, setFileNameSim] = useState('')
  const [fileNameKtp, setFileNameKtp] = useState('')
  const [showPreview, setShowPreview] = useState(false)
  const [previewUrl, setPreviewUrl] = useState('')
  const [previewName, setPreviewName] = useState('')
  const [previewType, setPreviewType] = useState('')

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  const handleShowPreview = (file, name) => {
    if (!file) return
    let url = file
    let type = ''
    if (typeof file !== 'string') {
      url = URL.createObjectURL(file)
      type = file.type
    }
    setPreviewUrl(url)
    setPreviewName(name || 'File Preview')
    setPreviewType(type)
    setShowPreview(true)
  }

  const handleSubmit = async (values, actions) => {
    try {
      setLoadingSubmit(true)
      let response = null
      if (values.typeDriver === 'internal') {
        response = await api.post('/master/driver/add', values)
      } else {
        const formData = new FormData()
        for (const key in values) {
          if (key === 'sim_doc' || key === 'ktp_doc') {
            continue
          }
          formData.append(key, values[key])
        }
        formData.append('docs[sim]', values.sim_doc)
        formData.append('docs[ktp]', values.ktp_doc)
        response = await api.postForm('/master/driver/add-external', formData)
      }
      if (response.data.success) {
        props.onHide()
        props.refreshData()
        Common.showPopUpSuccessMessage(response.data.message)
        if (values.typeDriver === 'external') {
          setFileNameKtp('')
          setFileNameSim('')
        }
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingSubmit(false)
    }
  }

  return (
    <>
      <Modal {...props} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Driver</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={DriverAddSchema}
            onSubmit={(values) => {
              handleSubmit(values)
            }}
          >
            {({
              handleBlur,
              handleSubmit,
              handleChange,
              values,
              errors,
              touched,
              isValid,
              dirty,
              setFieldValue
            }) => {
              return (
                <Form className="d-grid gap-2" onSubmit={handleSubmit}>
                  {props.activeKey === 'internal' && (
                    <>
                      <Row>
                        <Col md={6}>
                          <TextField
                            label="name"
                            name="name"
                            value={values.name}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            placeholder="Input Name"
                            required={true}
                          />
                        </Col>
                        <Col md={6}>
                          <TextField
                            label="phone number"
                            name="phone_number"
                            value={values.phone_number}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            placeholder="Input Phone Number"
                            required={true}
                          />
                        </Col>
                        <Col md={12}>
                          <TextField
                            label="address"
                            name="address"
                            value={values.address}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            placeholder="Input Address"
                            required={true}
                          />
                        </Col>
                        <Col md={12}>
                          <SelectInput
                            label="Status"
                            name="status"
                            id="status"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            options={statuses}
                            required={true}
                          />
                        </Col>
                        <Col md={6}>
                          <TextField
                            label="username"
                            name="username"
                            value={values.username}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            placeholder="Input Username"
                            required={true}
                          />
                        </Col>
                        <Col md={6}>
                          <Form.Label
                            className="text-muted text-uppercase"
                            style={{ fontSize: '13px', letterSpacing: '0.5px' }}
                          >
                            <small>Password</small>
                          </Form.Label>
                          <div className="password-input-container">
                            <input
                              type={showPassword ? 'text' : 'password'}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              id="password"
                              name="password"
                              className={`form-control mt-3 ${
                                touched.password && !!errors.password
                                  ? 'is-invalid'
                                  : ''
                              } `}
                              required
                              placeholder="******"
                              value={values.password}
                            />
                            {!errors.password && touched.password && (
                              <div
                                className="password-toggle-icon position-absolute"
                                onClick={togglePasswordVisibility}
                              >
                                {showPassword ? (
                                  <EyeOff size={16} />
                                ) : (
                                  <Eye size={16} />
                                )}
                              </div>
                            )}

                            {!!errors.password && touched.password && (
                              <Form.Control.Feedback type="invalid">
                                {errors.password}
                              </Form.Control.Feedback>
                            )}
                          </div>
                          <div
                            className="text-muted mt-1 ps-1"
                            style={{ fontSize: '11px', lineHeight: '1.4' }}
                          >
                            Password harus 8–20 karakter, mengandung huruf
                            besar, huruf kecil, angka, dan simbol.
                          </div>
                        </Col>
                      </Row>
                    </>
                  )}
                  {props.activeKey === 'external' && (
                    <>
                      <Row>
                        <Col md={6}>
                          <TextField
                            label="name"
                            name="name"
                            value={values.name}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            placeholder="Input Name"
                            required={true}
                          />
                        </Col>
                        <Col md={6}>
                          <SelectInput
                            label="Status"
                            name="status"
                            id="status"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            options={statuses}
                            required={true}
                          />
                        </Col>
                        <Col md={12}>
                          <Form.Group>
                            <Form.Label
                              className="text-muted"
                              style={{ fontSize: '13px' }}
                            >
                              SIM <sup style={{ color: 'red' }}>*</sup>
                            </Form.Label>
                            {fileNameSim === '' && (
                              <Card
                                style={{
                                  width: '3rem',
                                  height: '3rem',
                                  cursor: 'pointer'
                                }}
                                onClick={() => fileUploadSim.current.click()}
                              >
                                <Card.Body>
                                  <div style={{ marginTop: '-.3rem' }}>
                                    <Plus size={16} color="#828282" />
                                  </div>
                                </Card.Body>
                              </Card>
                            )}
                            {fileNameSim !== '' && (
                              <Card>
                                <Card.Body>
                                  <div className="d-flex h-100 align-items-center">
                                    <X
                                      size={20}
                                      color="#828282"
                                      style={{ cursor: 'pointer' }}
                                      onClick={() => {
                                        setFileNameSim('')
                                        setFieldValue('sim_doc', '')
                                      }}
                                    />
                                    <span
                                      className="ml-2 text-primary text-decoration-underline"
                                      style={{ cursor: 'pointer' }}
                                      onClick={() =>
                                        handleShowPreview(
                                          values.sim_doc,
                                          `SIM - ${values.name}`
                                        )
                                      }
                                    >
                                      {fileNameSim}
                                    </span>
                                  </div>
                                </Card.Body>
                              </Card>
                            )}
                            <input
                              type="file"
                              name="sim_doc"
                              accept="image/png,image/jpg,image/jpeg,image/webp,application/pdf"
                              onChange={(e) => {
                                setFieldValue('sim_doc', e.target.files[0])
                                setFileNameSim(e.target.files[0].name)
                              }}
                              onBlur={handleBlur}
                              className="d-none"
                              ref={fileUploadSim}
                            />
                            {!!errors.sim_doc && (
                              <p className="text-danger mt-2">
                                {errors.sim_doc}
                              </p>
                            )}
                          </Form.Group>
                        </Col>
                        <Col md={12} className="mt-3">
                          <Form.Group>
                            <Form.Label
                              className="text-muted"
                              style={{ fontSize: '13px' }}
                            >
                              KTP <sup style={{ color: 'red' }}>*</sup>
                            </Form.Label>
                            {fileNameKtp === '' && (
                              <Card
                                style={{
                                  width: '3rem',
                                  height: '3rem',
                                  cursor: 'pointer'
                                }}
                                onClick={() => fileUploadKtp.current.click()}
                              >
                                <Card.Body>
                                  <div style={{ marginTop: '-.3rem' }}>
                                    <Plus size={16} color="#828282" />
                                  </div>
                                </Card.Body>
                              </Card>
                            )}
                            {fileNameKtp !== '' && (
                              <Card>
                                <Card.Body>
                                  <div className="d-flex h-100 align-items-center">
                                    <X
                                      size={20}
                                      color="#828282"
                                      style={{ cursor: 'pointer' }}
                                      onClick={() => {
                                        setFileNameKtp('')
                                        setFieldValue('ktp_doc', '')
                                      }}
                                    />
                                    <span
                                      className="ml-2 text-primary text-decoration-underline"
                                      style={{ cursor: 'pointer' }}
                                      onClick={() =>
                                        handleShowPreview(
                                          values.ktp_doc,
                                          `KTP - ${values.name}`
                                        )
                                      }
                                    >
                                      {fileNameKtp}
                                    </span>
                                  </div>
                                </Card.Body>
                              </Card>
                            )}
                            <input
                              type="file"
                              name="ktp_doc"
                              accept="image/png,image/jpg,image/jpeg,image/webp,application/pdf"
                              onChange={(e) => {
                                setFieldValue('ktp_doc', e.target.files[0])
                                setFileNameKtp(e.target.files[0].name)
                              }}
                              onBlur={handleBlur}
                              className="d-none"
                              ref={fileUploadKtp}
                            />
                            {!!errors.ktp_doc && (
                              <p className="text-danger mt-2">
                                {errors.ktp_doc}
                              </p>
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                    </>
                  )}
                  <Modal.Footer className="mt-3">
                    <CustomCloseButton onClick={props.onHide} />
                    <CustomButton
                      onClick={handleSubmit}
                      variant={
                        !isValid || !dirty || loadingSubmit
                          ? 'secondary'
                          : 'warning'
                      }
                      disabled={!isValid || !dirty || loadingSubmit}
                      text={loadingSubmit ? 'Loading...' : 'Add'}
                      classNameValue={`text-white ${
                        !isValid || !dirty || loadingSubmit ? 'opacity-25' : ''
                      }`}
                    />
                  </Modal.Footer>
                </Form>
              )
            }}
          </Formik>
        </Modal.Body>
      </Modal>
      <FilePreviewModal
        show={showPreview}
        onHide={() => setShowPreview(false)}
        fileUrl={previewUrl}
        fileName={previewName}
        fileType={previewType}
      />
    </>
  )
}

export default ModalAddDriver
